import { render, staticRenderFns } from "./PaymentLogos.vue?vue&type=template&id=28ec89aa&scoped=true"
import script from "./PaymentLogos.vue?vue&type=script&lang=js"
export * from "./PaymentLogos.vue?vue&type=script&lang=js"
import style0 from "./PaymentLogos.vue?vue&type=style&index=0&id=28ec89aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ec89aa",
  null
  
)

export default component.exports